// ==== Products Slider ======
var productsSlider = new Swiper("[data-products-slider]", {
  slidesPerView: 1.5,
  spaceBetween: 8,
  navigation: {
    nextEl: "[data-products-slider-next]",
    prevEl: "[data-products-slider-prev]"
  },
  scrollbar: {
    el: "[data-products-slider-scrollbar]"
  },
  breakpoints: {
    768: {
      slidesPerView: 3.5

    },
    1200: {
      slidesPerView: 4.5,
      spaceBetween: 20
    }
  }
});

// ==== Collections Slider ====
var collectionSlider = new Swiper("[data-collection-slider]", {
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: "[data-collection-slider-next]",
    prevEl: "[data-collection-slider-prev]"
  }
});

var productsInnerSlider = new Swiper("[data-products-inner-slider]", {
  slidesPerView: 1.5,
  loop: false,
  spaceBetween: 8,
  navigation: {
    nextEl: "[data-products-inner-slider-next]",
    prevEl: "[data-products-inner-slider-prev]"
  },
  scrollbar: {
    el: "[data-products-inner-slider-scrollbar]"
  },
  breakpoints: {
    768: {
      slidesPerView: 3.5
    },
    1200: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    }
  }
});